import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';

import { CollaboratorAvatar } from 'components';

import styles from './Member.module.scss';

interface MemberProps {
  /** @boolean If the group heading should render with an alternate style */
  alternateStyle?: boolean;
  /** @boolean True if we're viewing this member's profile */
  active?: boolean;
  /** @User Member user data */
  collaborator: User;
  /** @function If undefined it will link to the user profile page */
  onClick?: (person: User) => void;
  /** @function Tracks when the member is clicked */
  onLinkClick?: (person: User) => void;
}

export const Member: React.FC<MemberProps> = ({
  alternateStyle,
  collaborator,
  onClick,
  onLinkClick,
}) => {
  const renderAsLink = onClick === undefined;
  const memberLink = `/profile/${collaborator.id}`;

  const renderCollaborator = React.useCallback(
    (collaborator: User) => {
      return (
        <>
          <CollaboratorAvatar
            bordered={false}
            className={styles.avatar}
            size={alternateStyle ? 'Small' : 'SubStandard'}
            collaborator={{
              displayName: collaborator.name || collaborator.email || '',
              emailAddress: collaborator.email,
              photoURL: collaborator.avatarUrl,
            }}
          />

          <span className={classnames(styles.name, alternateStyle && styles.alternate)}>
            {collaborator.name || collaborator.email}
          </span>
        </>
      );
    },
    [alternateStyle]
  );

  if (!memberLink) {
    return null;
  }

  return (
    <>
      {renderAsLink ? (
        <NavLink
          to={memberLink}
          title={collaborator.email}
          activeClassName={styles.active}
          onClick={() => onLinkClick && onLinkClick(collaborator)}
          className={classnames(styles.container, alternateStyle && styles.alternate)}
        >
          {renderCollaborator(collaborator)}
        </NavLink>
      ) : (
        <div
          className={styles.container}
          onClick={() => onClick && onClick(collaborator)}
          title={collaborator.email}
        >
          {renderCollaborator(collaborator)}
        </div>
      )}
    </>
  );
};

export default Member;
